import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  FriendsCard,
  Loading,
  PostCard,
  ProfileCard,
  TopBar,
} from "../components";
import { deletePost, fetchPosts, getUserInfo, likePost } from "../utils";

const Profile = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { posts } = useSelector((state) => state.posts);
  const [userInfo, setUserInfo] = useState(user);
  const [loading, setLoading] = useState(false);

  const uri = "/posts/get-user-post/" + id;

  const getUser = async () => {
    const res = await getUserInfo(user?.token, id)
    setUserInfo(res)
  }

  const getPosts = async () => {
    await fetchPosts(user.token, dispatch, uri);
    setLoading(false)
  }

  const handleDelete = async (id) => {
    await deletePost(id, user.token);
    await getPosts();
  };
  const handleLikePost = async (uri) => {
    await likePost({uri: uri, token: user?.token});
    await getPosts();
  };

  useEffect(()=> {
    setLoading(true)
    getUser()
    getPosts()
  },[id])

  return (
    <>
      <div className='home w-full px-0 md:px-4 bg-bgColor h-screen overflow-auto'>
        <TopBar />
        {/* md:h-full */}
        <div className='w-full flex flex-col lg:flex-row justify-center items-center overflow-auto md:justify-normal md:items-start lg:h-full gap-2 lg:gap-4 pt-2 '>
          {/* LEFT md:h-full */}
          <div className='w-full  lg:w-[30%]  md:flex flex-col gap-6 overflow-y-auto lg:h-full'> 
            <ProfileCard user={userInfo} />

            <div className='block md:hidden'>
              <FriendsCard friends={userInfo?.friends} />
            </div>
          </div>

          {/* CENTER */}
          <div className=' flex-1 h-full bg-orimary px-4 flex flex-col gap-6 overflow-y-auto rounded-lg'>
            {loading ? (
              <Loading />
            ) : posts?.length > 0 ? (
              posts?.map((post) => (
                <PostCard
                  post={post}
                  key={post?._id}
                  user={user}
                  deletePost={handleDelete}
                  likePost={handleLikePost}
                />
              ))
            ) : (
              <div className='flex w-full h-full items-center justify-center'>
                <p className='text-lg text-ascent-2'>No Post Available</p>
              </div>
            )}
          </div>

          {/* RIGHT */}
          <div className='hidden w-[30%] h-full lg:flex flex-col gap-8 overflow-y-auto'>
            <FriendsCard friends={userInfo?.friends} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;